export default {

  install: (Vue) => {
    Vue.prototype.dialog = {

      alert (message) {
        return new Promise((resolve, reject) => {
          Event.$emit('showModal', message)
          Event.$on('closeModal', accept => {
            resolve(accept)
          })
        })
      },

      confirm ({message, okText, koText, koStyle}) {
        return new Promise((resolve, reject) => {
          Event.$emit('showConfirm', {message, okText, koText, koStyle})
          Event.$on('closeConfirm', accept => {
            if (accept) {
              resolve(accept)
            } else {
              reject(message)
            }
          })
        })
      },

      confirmCountdown () {
        return new Promise((resolve, reject) => {
          Event.$emit('showConfirmCountdown')
          Event.$on('closeConfirmCountdown', accept => {
            if (accept) {
              resolve(accept)
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          })
        })
      },

      uploadAnswerFile ({typeAnswer}) {
        return new Promise((resolve, reject) => {
          Event.$emit('showUploadAnswerFile', {typeAnswer})
          Event.$on('closeUploadAnswerFile', accept => {
            if (accept) {
              resolve(accept)
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          })
        })
      },

      updateAnswerFile (data) {
        return new Promise((resolve, reject) => {
          Event.$emit('showUpdateAnswerFile', data)
          Event.$on('closeUpdateAnswerFile', accept => {
            if (accept) {
              resolve(accept)
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          })
        })
      },

      userBroadcastMessages (data) {
        return new Promise((resolve, reject) => {
          Event.$emit('showUserBroadcastMessages', data)
          Event.$on('closeUserBroadcastMessages', accept => {
            if (accept) {
              resolve(accept)
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          })
        })
      },

      consultReason () {
        return new Promise((resolve, reject) => {
          Event.$emit('showConsultReason')
          Event.$on('closeConsultReason', accept => {
            if (accept[0]) {
              resolve(accept[1])
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dialog.js